export default __webpack_public_path__ + "static/avenir-next-regular-52012ae4677a8824eda7385ebf13b689.woff2";